enum ShiftStatus {
  unconfirmed = "未確認",
  verified = "確認済み",
}

export default ShiftStatus;
